import { Bracket, Taxes, calculateTaxes } from "./taxes";
import { TaxesInput, TypeOfActivity } from "./taxesinput";
import { personalIncomeBrackets, personalIncomeTaxDependentsExempt, socialContributionMainBrackets, socialContributionSecondaryBrackets } from "./taxesmasterdata";

export function socialContribution(income: number, typeOfActivity: TypeOfActivity): number {
    if (typeOfActivity === TypeOfActivity.Main) {
        return calculateTaxes(income, socialContributionMainBrackets)
    } else {
        return calculateTaxes(income, socialContributionSecondaryBrackets)
    }
}

function calculatePersonalIncomeBrackets(dependents: number): Array<Bracket> {
    const brackets = personalIncomeBrackets()
    const taxFreeBracket = brackets.find((bracket) => bracket.percentageTax === 0 && bracket.fixedTax === 0)
    if (taxFreeBracket === undefined) {
        throw new Error("Assumption violated. This code expects that there is a tax free bracket in the personal income tax.")
    }

    taxFreeBracket.upperBound = taxFreeBracket.upperBound + personalIncomeTaxDependentsExempt(dependents)

    // Changing the upperBound of the tax free bracket might have caused it to overtake another bracket.
    // We remove those other brackets.
    return brackets.filter((bracket) => bracket.upperBound >= taxFreeBracket.upperBound)
}

export function personalIncomeTax(income: number, dependents: number): number {
    const brackets = calculatePersonalIncomeBrackets(dependents)

    return calculateTaxes(income, brackets)
}

export function calculateSoleProprietorshipTaxes(input: TaxesInput): Taxes {
    // Fun fact: social contribution depends on income, which in turn depends on social contribution.
    // If the calculation of the social contribution would be a sane mathematical function, we write an equation and solve for social contribution.
    // But the calculation depends on brackets and type of activity. So, nice mathematical equations are out of the window.
    // Let's loop until the difference is minimal, I guess...
    let lastIncome = input.turnOver - input.expenses

    let taxes = new Taxes(socialContribution(lastIncome, input.typeOfActivity),
        personalIncomeTax(lastIncome, input.dependents), 0, 0);
    let newIncome = input.turnOver - input.expenses - taxes.socialContribution;

    // We have no formal proof that this value converges, so we put an iteration cap on it.
    let iterations = 0;
    while (Math.abs(lastIncome - newIncome) > 100 && iterations < 100) {
        ++iterations;
        taxes = new Taxes(socialContribution(newIncome, input.typeOfActivity),
            personalIncomeTax(newIncome, input.dependents), 0, 0);
        lastIncome = newIncome;
        newIncome = input.turnOver - input.expenses - taxes.socialContribution;
    }

    return taxes;
}